import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import {
    Redirect,
    Route,
    Switch,
    useParams,
    useRouteMatch,
    useLocation,
    useHistory
} from 'react-router-dom';
import NewForm from './Form/NewForm';
import { useDispatch, useSelector } from 'react-redux';
import { getFormEntries, getForms } from '../../redux/DynamicForms/DynamicFormsAction';
import useCheckMobileScreen from '../../hooks/useWidth';
import FormStructure from './Form/FormStructure/index';
import FormEntries from './Form';
import ComparisonForm from './Comparison/ComparisonForm';
import { getClinicId, getNamespace } from '../../utils/storage';
import useForbidden from '../../hooks/useForbidden';
import FormComparisonLinks from './Comparison/FormComparisonLinks';
import useCheckAccess from '../../hooks/useCheckAccess';

const styles = makeStyles((theme) => ({
    col3: {
        flex: '0 1 75%',
        // padding: '24px',
        // height: '100%',
        overflowX: 'auto'
    },
    colContainer: {
        padding: '24px',
        height: '100%',
        [theme.breakpoints.down(1025)]: {
            padding: '0'
        }
    }
}));

const Forms = () => {
    const isMobile = useCheckMobileScreen();
    const params = useParams();
    const { pathname } = useLocation();
    const history = useHistory();
    const patientId = +params?.id;
    const { path } = useRouteMatch();
    const url = `patient/${patientId}/forms`;
    const classes = styles();
    const dispatch = useDispatch();
    // const isComparison = pathname.split('/').filter((path) => path)[3] === 'comparison';
    const isNewForm = pathname?.split('/').filter((path) => path)[5] === 'newForm';
    const { notAccess } = useForbidden();
    const { notEditClinical } = useCheckAccess();
    const clinicId = getClinicId();
    const existFormId = pathname?.split('/').filter((path) => path)[5];
    const changingClinic = useSelector((state) => state.user.changingClinic);

    useEffect(() => {
        const fetch = async () => {
            const param = {
                subject_key: 'patient',
                subject_id: patientId,
                clinic: clinicId,
                offset: 0,
                limit: 10
            };
            const res = await dispatch(getFormEntries(param));
            if (!notAccess && clinicId && (!existFormId || isNaN(existFormId))) {
                if (!isMobile && !isNewForm && !pathname.includes('comparison')) {
                    if (res?.status === 200 && res?.data?.entries?.length) {
                        history.replace(
                            `/${params?.clinicId}/${url}/form/${res.data?.entries[0]?.id}`
                        );
                    } else {
                        history.replace(`/${params?.clinicId}/${url}/form/newForm`);
                    }
                }
            }
        };
        if (!changingClinic) {
            fetch();
        }
    }, [patientId, isMobile, notAccess, clinicId, changingClinic]);

    useEffect(() => {
        const namespace = getNamespace();
        if (namespace) {
            dispatch(getForms(namespace));
        }
    }, []);

    // useEffect(() => {
    //     if (isMobile) {
    //         if (isNewForm) {
    //             history.push(url);
    //         }
    //     }
    // }, [isMobile, isNewForm]);
    const Routes = [
        {
            id: 1,
            path: `${path}/form`,
            component: FormEntries,
            isMobile: true,
            exact: isNewForm ? false : true
        },
        {
            id: 2,
            path: `${path}/comparison`,
            component: FormComparisonLinks,
            isMobile: true,
            exact: true
        },
        {
            id: 3,
            path: `${path}/form/newForm`,
            component: NewForm,
            isMobile: false,
            access: notEditClinical,
            exact: true
        },

        {
            id: 4,
            path: `${path}/form/:form_id`,
            component: FormStructure,
            access: notEditClinical && isNaN(existFormId),
            exact: true
        },
        {
            id: 5,
            path: `${path}/comparison/:formId`,
            component: ComparisonForm,
            exact: true
        }
    ];
    return (
        <div className={classes.col3}>
            <div className={classes.colContainer}>
                <Switch>
                    {Routes.filter((item) => item.isMobile !== !isMobile && !item.access).map(
                        (route) => (
                            <Route key={route.id} {...route} />
                        )
                    )}
                    <Redirect from="*" to={`/${params?.clinicId}/${url}/form`} />
                </Switch>
                {isMobile ? <Route path={`${path}/form/newForm`} component={NewForm} /> : null}
            </div>
        </div>
    );
};

export default Forms;
